var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import Container from '../Container';
import { spacingToRem } from '../../utils/units';
var GraphWrapper = styled(Container)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: -5px;\n  right: ", ";\n"], ["\n  position: absolute;\n  top: -5px;\n  right: ", ";\n"])), function (props) { return spacingToRem('small', props.theme.spacing, true); });
export { GraphWrapper };
var templateObject_1;
//# sourceMappingURL=styles.js.map